'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = contextMenuReducer;

var _contextMenuActions = require('./contextMenuActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    visible: false,
    component: null,
    componentProps: null,
    position: null,
    customHide: false
};

function contextMenuReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _contextMenuActions.SHOW:
            return (0, _extends3.default)({}, state, {
                visible: true,
                component: action.component,
                componentProps: action.componentProps,
                position: action.position,
                customHide: action.customHide
            });
        case _contextMenuActions.HIDE:
            return (0, _extends3.default)({}, initialState);
        default:
            return state;
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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